import React, { useEffect, useState } from "react";

import versionsApi from "apis/versions";
import { Table, Pagination, Toastr } from "clearsense-ui/components";

import { HISTORY_COLUMNS } from "./constants";

import { PAGE_SIZE_OPTIONS } from "../../constants";

const History = ({ data }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [history, setHistory] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sort, setSort] = useState("created_at desc");

  const fetchHistory = async () => {
    setIsLoading(true);
    try {
      const params = {
        subject_id: data.primary[0].subject_id,
        page: pageNumber,
        per_page: pageSize,
        sort,
      };
      const response = await versionsApi.fetchVersions({ params });
      setHistory(response.data.changes);
      setTotalRecords(response.data.total_count);
    } catch (error) {
      Toastr.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, [pageSize, pageNumber, sort]);

  useEffect(() => {
    if (pageSize * pageNumber > history.length) {
      setPageNumber(1);
    }
  }, [pageSize]);

  const handleTableChange = sorter => {
    if (!sorter.order) {
      setSort("created_at desc");
    } else {
      setSort(`${sorter.field} ${sorter.order === "ascend" ? "asc" : "desc"}`);
    }
  };

  return (
    <div style={{ height: "90%" }}>
      <Table
        fixedHeight
        columnData={HISTORY_COLUMNS}
        rowData={history}
        loading={isLoading}
        onChange={(_pagination, _filters, sorter) => handleTableChange(sorter)}
      />
      <Pagination
        showResultsPerPage
        currentPage={pageNumber}
        pageSize={pageSize}
        totalRecordsCount={totalRecords}
        setCurrentPage={setPageNumber}
        setPageSize={setPageSize}
        pageSizeOptionsList={PAGE_SIZE_OPTIONS}
      />
    </div>
  );
};

export default History;
